import React, { useEffect, useState } from 'react';
 
import { useModal } from 'src/hooks/Modal';
import { BigDescription, BigTitle, BlockContainer, BlockContainerModal, BlockExternalContainer, BlockInternalContainer, Category, DateContainer, Image, ImageProgram, Paragraph, SearchContainer, TextContainer, Title } from './styles';
import { useConfiguration } from 'src/hooks/Configuration';
 
import { EditableDiv } from '../../../styles';
import SocialShare from '../components/ShareOptions';
 
import useProgramHook from './hooks/program';
import { useLanguage } from 'src/hooks/Language';
import SpeakerImages from './modules/SpeakerImages';
import { FaChevronDown, FaChevronUp, FaSearch } from 'react-icons/fa';
import SearchContainerComponent from '../../../Components/SearchContainerComponent';
import { FiCalendar } from 'react-icons/fi';
import AddToCalendarMini from '../AddToCalendarMini';
import CategoriesImages from './modules/CategoriesImages';
import { config } from 'react-spring';
import { websitePath } from 'src/config';

interface IProps {
    list: Record<string, any>;
    computer: Record<string, any>;
    mobile: Record<string, any>;
    component_styles?: Record<string, any>;
      configs?: Record<string, any>;
}




const hourConnector = {
  ptBr: ' às ',
  es: ' a ',
  en: ' to ',
};

const DataLine = ({  component_styles, configs, item, computer, mobile }: any) => {
  const {configuration } = useConfiguration();
  const [active, setActive] = useState(false);
    const { addModal } = useModal();
    const {language, translate} = useLanguage();

  
    const hour_start = item?.hour_start ? item?.[`hour_start_${language}`] ? item?.[`hour_start_${language}`] : item?.hour_start : '';
    const hour_end = item?.hour_end ? item?.[`hour_end_${language}`] ? item?.[`hour_end_${language}`] : item?.hour_end : '';
const date = hour_start && hour_end ? `${hour_start}${hourConnector[language]}${hour_end}` : hour_start || '';

const title = item?.title ? item?.[`title_${language}`] ? item?.[`title_${language}`] : item?.title : '';
const category = item?.category_title ? item?.[`category_title_${language}`] ? item?.[`category_title_${language}`] : item?.category_title : '';
const room_title = item?.room_title ? item?.[`room_title_${language}`] ? item?.[`room_title_${language}`] : item?.room_title : '';
 
const description = item?.description ? item?.[`description_${language}`] ? item?.[`description_${language}`] : item?.description : '';
 
 
    return <>
  
    <BlockContainer border={item?.category_border || item?.room_border}  className='column full-width' component_styles={component_styles} >
        {(item?.image || item?.main_category?.content_image) && configs?.show_image !== 'Não' ? <ImageProgram onClick={() =>  configs?.always_show_description ? false : setActive(!active)} src={`${websitePath}/${item?.image || item?.main_category?.content_image}`} component_styles={component_styles} /> : <></>}
        <TextContainer component_styles={component_styles}>
             
        
  
            <div className='row gap-sm  full-width' onClick={() =>  configs?.always_show_description ? false : setActive(!active)} style={{padding: '0px', justifyContent: 'space-between'}}>
       <div className='row-start gap-sm  ' style={{width: 'auto'}}>         
        <DateContainer component_styles={component_styles}><FiCalendar style={{marginTop:'5px'}} size={20}/> </DateContainer><DateContainer component_styles={component_styles}>{date}</DateContainer>
{configs?.show_category_button === 'Sim' ?  <Category background={item?.category_background || configs?.category_button_background} color={item?.category_color || configs?.category_button_color} component_styles={component_styles} dangerouslySetInnerHTML={{ __html: category }} /> : <></>} 
{configs?.show_room_button === 'Sim' ? <Category background={item?.room_background || configs?.room_button_background} color={item?.room_color || configs?.room_button_color} component_styles={component_styles} dangerouslySetInnerHTML={{ __html: room_title }} /> : <></>}
 </div>   
{ configs?.always_show_description !== 'Sim' && item?.description ? <div onClick={() =>  configs?.always_show_description ? false : setActive(!active)}>
 <FaChevronUp style={{cursor: 'pointer',transition: '0.3s all',transform: `rotate(${active ? 0 : -180}deg`}} size={configs?.arrow_size || 20} color={configs?.arrow_color || '#333'}/> 
</div> : <></>}
            </div>
            <Title onClick={() =>  configs?.always_show_description === 'Sim' ? false : setActive(!active)} component_styles={component_styles} dangerouslySetInnerHTML={{ __html: title }} />
            {configs?.show_short_description === 'Sim' && item?.short_description ? <Paragraph component_styles={component_styles} dangerouslySetInnerHTML={{ __html: item?.short_description }} /> : <></>}
          
          
            {configs?.show_description === 'Sim' && (active || configs?.always_show_description === 'Sim')  && description ? <Paragraph component_styles={component_styles} dangerouslySetInnerHTML={{ __html: description }} /> : <></>}
            <div className='row-start gap-xs'>
              
              {item?.categories?.length > 0 ? <CategoriesImages component_styles={component_styles} program={item}/> : <></>}
              
              {item?.speakers?.length > 0 ? <SpeakerImages component_styles={component_styles} program={item}/> : <></>}  {item?.start_hour && item?.end_hour ? <AddToCalendarMini event={
        
           
           {
                 title: title,
    description: description,
    location: configuration?.title,
    startTime: item.start_hour,
    endTime: item.end_hour
              }
              
            } /> : <></>} 
            
            
            
            </div>
               {item?.url ? <a href={item?.url}  id={item?.url_id} target='_BLANK'><button className='greenButton3'>{translate('Inscreva-se!')}</button></a> : <></>}
       
        </TextContainer>
    </BlockContainer>
</>
}





const ProgramWidget: React.FC<IProps> = ({ component_styles, configs,  computer, mobile }) => {
 const {language, translate, translateProperty} = useLanguage();
    computer['flex-wrap'] = 'wrap';
   

       const {filteredData, loadProgram, filter, changeFilter,   searchProps} = useProgramHook({configs});


      

    useEffect(() => {
 
        loadProgram()

    },[])


    

    return (<>
    
    <SearchContainerComponent filter={filter} changeFilter={changeFilter} component_styles={component_styles} configs={configs} searchList={searchProps}/>
    
    <BlockExternalContainer   className='column' component_styles={component_styles}>
       {filteredData?.map( container => {

   return <BlockInternalContainer    component_styles={component_styles}>
            <BigTitle component_styles={component_styles}>{ translateProperty({item: container, property: 'title', language})  }</BigTitle>
            <EditableDiv className=' full-width' computer={computer} mobile={mobile}>
  {container?.programs?.map(item => <DataLine configs={configs} item={item} component_styles={component_styles} computer={computer} mobile={mobile} />)}
  
 </EditableDiv>
 </BlockInternalContainer>
        })}
     

 

    </BlockExternalContainer></>);
};
export default ProgramWidget;
